<template>
  <base-form :can-back="isEnableBack">
    <slot />

    <template #submit-button>
      <confirm-button v-if="isRequestMode" class="px-5" />
      <application-button v-else-if="canShowApplicationButton" class="px-5" />
    </template>

    <template #expansion-buttons-center>
      <slot name="expansion-buttons-center" />
    </template>

    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import ConfirmButton from '@/views/molecules/buttons/ConfirmButton'
import ApplicationButton from '@/views/molecules/buttons/ApplicationButton'

export default {
  name: 'RequestForm',
  components: {
    BaseForm,
    ConfirmButton,
    ApplicationButton,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    buildingName: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: 'Request',
    },
    canBack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEnableBack() {
      return this.canBack && !this.$store.state.account.is_guest
    },
    isRequestMode() {
      return this.mode === 'Request'
    },
    canShowApplicationButton() {
      return this.mode === 'Confirm' && (this.buildingName !== null || this.id !== null)
    },
  },
}
</script>